import React from "react";
import { useForm } from "@refinedev/react-hook-form";
import { useSelect } from "@refinedev/core";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { FormField } from "@/components/ui/form-field";
import { CreatePage } from "@/components/crud";
import { IBranch } from "../../types";

export const BranchCreate: React.FC = () => {
  const {
    refineCore: { onFinish, formLoading },
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm<IBranch>();

  const { options } = useSelect({
    resource: "companies",
    optionLabel: "name",
    optionValue: "id",
  });

  return (
    <CreatePage>
      <form onSubmit={handleSubmit(onFinish)}>
        <Card>
          <CardHeader>
            <CardTitle>Branch Information</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <FormField label="Company" required error={errors.company?.message as string}>
                <select
                  className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
                  {...register("company", { required: "Please select a company!" })}
                >
                  <option value="">Select company</option>
                  {options?.map((opt) => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </FormField>
              <FormField label="Branch Name" required error={errors.name?.message as string}>
                <Input {...register("name", { required: "Please input the branch name!" })} placeholder="Enter branch name" />
              </FormField>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <FormField label="Branch Code" required error={errors.code?.message as string}>
                <Input {...register("code", { required: "Please input the branch code!" })} placeholder="Enter branch code" />
              </FormField>
              <FormField label="Phone">
                <Input {...register("phone")} placeholder="Enter phone number" />
              </FormField>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <FormField label="Email" error={errors.email?.message as string}>
                <Input {...register("email", { pattern: { value: /^\S+@\S+$/i, message: "Please enter a valid email!" } })} placeholder="Enter email address" />
              </FormField>
            </div>
            <FormField label="Address">
              <Textarea {...register("address")} rows={3} placeholder="Enter branch address" />
            </FormField>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <FormField label="Main Branch">
                <Switch
                  checked={watch("is_main") ?? false}
                  onCheckedChange={(v) => setValue("is_main", v)}
                />
              </FormField>
              <FormField label="Active">
                <Switch
                  checked={watch("is_active") ?? true}
                  onCheckedChange={(v) => setValue("is_active", v)}
                />
              </FormField>
            </div>
          </CardContent>
        </Card>
        <div className="flex justify-end mt-6">
          <Button type="submit" disabled={formLoading}>Save</Button>
        </div>
      </form>
    </CreatePage>
  );
};
